module.exports = __webpack_public_path__ + "assets/images/project/lion.jpg?v=8d7a4ac9";